import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import * as S from "./styled";
import * as Typos from "src/components/atoms/Typographs";
import { Submit } from "src/components/atoms/Buttons";
import routes from "src/constants/routes";
import ACTIONS from "src/redux/actions";
import giftService from "src/services/gift.service";
import { imageUrlFor } from "src/utils/sanity";
import Images from "src/theme/Images";
import userService from "src/services/user.service";
import wishService from "src/services/wish.service";
import friendService from "src/services/friend.service";
import eventService from "src/services/event.service";
import FolloweeCell from "./FolloweeCell";
import SummaryList from "../Calendars/SummaryList";
import {
  EVENT_EX,
  FOLLOWING_EX,
  HOME_WISHLIST_EX,
  MY_EVENTS_EX,
  USER_EX,
  WISHLIST_EX,
} from "src/constants/placeholders";

import LOGINACTION from "src/redux/actions";
import { LOGIN_NAVIGATE_BUTTON } from "src/theme/Labels";
import { Btn } from "src/theme/Styled";
import ShareModal from "../ShareModal";
import Modal from "react-responsive-modal";

const MyProfile = () => {
  const user = useSelector((state) => state.users?.user);
  const interests = useSelector(
    (state) => state.users?.configurations?.interests || []
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [gifts, setGifts] = useState([]);
  const [items, setItems] = useState([]);
  const [friends, setFriends] = useState([]);
  const [followees, setFollowees] = useState([]);
  const [myEvents, setMyEvents] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [loadingGifts, setLoadingGifts] = useState(false);
  const [loadingFriendEvents, setLoadingFriendEvents] = useState(false);
  const [loadingMoreFriendEvents, setLoadingMoreFriendEvents] = useState(false);
  const [loadingMoreWishes, setLoadingMoreWishes] = useState(false);
  const [loadingMoreFriends, setLoadingMoreFriends] = useState(false);
  const [loadingMoreFollowings, setLoadingMoreFollowings] = useState(false);
  const [hasMoreWishes, setHasMoreWishes] = useState(false);
  const [hasMoreFriends, setHasMoreFriends] = useState(false);
  const [hasMoreFollowings, setHasMoreFollowings] = useState(false);

  const [isShare, setIsShare] = useState(false);
  const [itemToShare, setItemToShare] = useState(null);
  const [isLoginModal, setisLoginModal] = useState(false);

  const settings3 = {
    slidesToShow: 6,
    slidesToScroll: 6,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    infinite: false,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  const settings = {
    slidesToShow: 5,
    slidesToScroll: 5,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    infinite: false,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const openShare = () => {
    setItemToShare({ username: user?.username, fullname: user?.firstname + " " + user?.lastname });
    setIsShare(true);
  };

  const showLoginModal = () => {
    setisLoginModal(true);
  };

  const openSign = () => {
    setisLoginModal(false);
    dispatch({
      type: LOGINACTION.SIDEBAR.OPEN_SIGN,
    });
  };

  const fetchMyEvents = () => {
    setLoadingEvents(true);
    eventService
      .loadMine()
      .then((data) => {
        setLoadingEvents(false);
        const currentMonth = new Date().getMonth() * 30;
        data.sort((a, b) => {
          let aDiff = (a.month - 1) * 30 + a.day - currentMonth;
          let bDiff = (b.month - 1) * 30 + b.day - currentMonth;
          aDiff < 0 ? (aDiff = 1000 + aDiff) : false;
          bDiff < 0 ? (bDiff = 1000 + bDiff) : false;
          return aDiff - bDiff;
        });
        setMyEvents(data);
        dispatch({
          type: ACTIONS.USER.SET_EVENTS,
          payload: data,
        });
      })
      .catch(() => {
        setLoadingEvents(true);
      });
  };

  const fetchUserData = () => {
    setLoading(true);
    userService
      .loadMyProfile()
      .then((data) => {
        setLoading(false);
        const results = {};
        for (let dataItem of data) {
          for (let key in dataItem) {
            results[key] = dataItem[key];
          }
        }
        const wishItems = results.wish || [];
        if (wishItems.length >= 10) {
          setHasMoreWishes(true);
          wishItems.splice(9);
        } else {
          setHasMoreWishes(false);
        }
        setItems(wishItems);

        const friendItems = results.friends || [];
        if (friendItems.length >= 10) {
          setHasMoreFriends(true);
          friendItems.splice(9);
        } else {
          setHasMoreFriends(false);
        }
        setFriends(friendItems);

        const followeeItems = results.followees.filter(x => x.user != null) || [];
        if (followeeItems.length >= 10) {
          setHasMoreFollowings(true);
          followeeItems.splice(9);
        } else {
          setHasMoreFollowings(false);
        }
        setFollowees(followeeItems);

        setEvents(results.events || []);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const fetchTrendingGifts = () => {
    giftService
      .loadRecommend(0, 13, "trending == true")
      .then((data) => {
        setLoadingGifts(false);
        setGifts(data);
      })
      .catch(() => {
        setLoadingGifts(false);
      });
  };

  const fetchGifts = async () => {
    setLoadingGifts(true);
    const interestRefs = [];
    interests.forEach((e) => {
      const interestItem = e.title.toLowerCase();
      if (user?.interestings?.[interestItem]) {
        interestRefs.push(e._id);
      }
    });
    if (!interestRefs.length) {
      fetchTrendingGifts();
    } else {
      const query = `interests[0]._ref in ["${interestRefs.join('","')}"]`;
      const configurations = await giftService.getConfigurations();

      // const dem
      giftService
        .loadRecommend(0, 100, query)
        .then((data) => {
          const updatedArr = data.map((gift) => {
            const demoData = [];
            const ageGroupsData = [];
            configurations?.demos?.forEach((demo) => {
              gift.demo.forEach((item) =>
                item._ref === demo?._id
                  ? demoData.push({ ...item, title: demo.title })
                  : null
              );
            }); 
           
            return { ...gift, demo: demoData };
          });

          const adultsData = updatedArr.filter((el) =>
            el.ageGroups?.find((e) => e._ref === '3b24cdf5-4164-4544-a0de-161f646882e3')
          );         

          let userGender = user?.gender?.toLowerCase();
          // UNCOMMENT THIS CODE IF WE HAVE TO USE 'HE' FOR 'HIM' AND 'SHE' FOR 'HER'
          if (userGender === "he") {
            userGender = "him";
          } else if (userGender === "she") {
            userGender = "her";
          }

          const giftsForUser = adultsData.filter((el) =>
            el.demo?.find((e) => e.title?.toLowerCase() === userGender)
          );

          setLoadingGifts(false);
          // console.log({ giftsForUser, updatedArr });

          if (giftsForUser?.length) {
            setGifts(giftsForUser);
          } else {
            fetchTrendingGifts();
          }
        })
        .catch(() => {
          setLoadingGifts(false);
        });
    }
  };

  const filterFriendEvents = (month) => {
    setLoadingFriendEvents(true);
    eventService
      .filterEvents({ month })
      .then((data) => {
        setLoadingFriendEvents(false);
        setEvents(data);
      })
      .catch((err) => {
        setLoadingFriendEvents(false);
      });
  };

  const loadMoreFriendEvents = (month) => {
    setLoadingMoreFriendEvents(true);
    eventService
      .filterEvents({ month, skip: 15 })
      .then((data) => {
        setLoadingMoreFriendEvents(false);
        setEvents([...events, ...data]);
      })
      .catch((err) => {
        setLoadingMoreFriendEvents(false);
      });
  };

  const loadMoreWishItems = () => {
    if (loadingMoreWishes) {
      return;
    }
    setLoadingMoreWishes(true);
    const skip = items.length;
    wishService
      .load({ skip, limit: 11 })
      .then((data) => {
        const resItems = data.items || [];
        setLoadingMoreWishes(false);
        if (resItems.length > 10) {
          setHasMoreWishes(true);
        } else {
          setHasMoreWishes(false);
        }
        resItems.splice(10);
        setItems([...items, ...resItems]);
      })
      .catch((err) => {
        setLoadingMoreWishes(false);
      });
  };

  const loadMoreFriends = () => {
    if (loadingMoreFriends) {
      return;
    }
    setLoadingMoreFriends(true);
    const skip = friends.length;
    friendService
      .loadFriends({ skip, limit: 11 })
      .then((data) => {
        const resItems = data.items || [];
        setLoadingMoreFriends(false);
        if (resItems.length > 10) {
          setHasMoreFriends(true);
        } else {
          setHasMoreFriends(false);
        }
        resItems.splice(10);
        setFriends([...friends, ...resItems]);
      })
      .catch((err) => {
        setLoadingMoreFriends(false);
      });
  };

  const loadMoreFollowings = () => {
    if (loadingMoreFollowings) {
      return;
    }
    setLoadingMoreFollowings(true);
    const skip = followees.length;
    friendService
      .loadFollowees({ skip, limit: 11 })
      .then((data) => {
        const resItems = data.items || [];
        setLoadingMoreFollowings(false);
        if (resItems.length > 10) {
          setHasMoreFollowings(true);
        } else {
          setHasMoreFollowings(false);
        }
        resItems.splice(10);
        setFollowees([...followees, ...resItems]);
      })
      .catch((err) => {
        setLoadingMoreFollowings(false);
      });
  };

  useEffect(() => {  
    if (user) {
      fetchGifts();
      fetchUserData();
      fetchMyEvents();
    }
    setisLoginModal(user ? false : true);
  }, []);

  const onFollowSuccess = (item, already = false) => {
    followees.some((e, index) => {
      if (e.user?._id === item.user?._id) {
        followees.splice(index, 1);
        return true;
      }
    });
    setFollowees([...followees]);
    if (already) {
      return;
    }
    const friend = {
      ...item,
      friend: item.user,
    };
    setFriends([...friends, friend]);

    dispatch({
      type: ACTIONS.USER.ADD_FRIEND,
      payload: item.user._id,
    });
  };

  const openGuide = () => {
    dispatch({
      type: ACTIONS.SIDEBAR.OPEN_GUIDE,
    });
  };

  const goToUpdate = () => {
    navigate(routes.UPDATE_PROFILE);
  };

  const _renderMainSection = () => {
    return (
      <div className="main-info-section mt-4">
        <div className="avatar">
          {
            user ? (user === null ? (<img src={Images.account_icon} alt="Login" className="image-avatar" />) : (
              <img src={user?.avatar} alt="avatar" className="image-avatar" onClick={goToUpdate} />
            )
            ) : (
              <div
                className={user === null ? "user-icon" : "name-avatar"}
                onClick={goToUpdate}
              >
                {user === null && <img src={Images.account_icon} alt="Login" className="image-avatar" />}

                <Typos.Desc className="text-white">
                  {user?.firstname[0]}
                  {user?.lastname[0]}
                </Typos.Desc>
              </div>
            )}
        </div>
        <div className="name-events">
          <Typos.PageTitle className="mb-0 ml-4">
            Welcome {user ? user?.firstname : "User"}
          </Typos.PageTitle>
          <div className="guide-text">
            <Typos.H5>
              Complete{" "}
              <span className="td-underline c-pointer" onClick={openGuide}>
                these steps
              </span>{" "}
              to get the most out of The Gift Guide
            </Typos.H5>
          </div>
          {_renderMyEventsSection()}
        </div>
        <div className="actions profile_section">
          <Btn
            theme="outline"
            className="justify-content-end w-auto"
            style={{ whiteSpace: "nowrap" }}
            onClick={user ? openShare : showLoginModal}
          >
            <img src={Images.shareIcon} alt="icon" />
            <span>SHARE MY WISH LIST</span>
          </Btn>
        </div>
      </div>
    );
  };

  const _renderEventCell = (event, index) => {
    const dates = [event.month, event.day];

    return (
      <div key={event._id + "-" + index} className="d-flex">
        <Typos.Desc className="event-date">{dates.join(".")}</Typos.Desc>
        <Typos.Desc>{event.name}</Typos.Desc>
      </div>
    );
  };

  const _renderPlaceholderEvent = (event, index) => {
    const dates = [event.month, event.day];

    return (
      <div key={index} className="d-flex placeholder-item">
        <Typos.Desc className="event-date fake-text">
          {dates.join(".")}
        </Typos.Desc>
        <Typos.Desc className="fake-text">{event.event_name}</Typos.Desc>
      </div>
    );
  };
  const _renderMyEventsSection = () => {
    return (
      <div className="my-events" style={{ paddingTop: "32px" }}>
        {user ? (
          <Link
            className="section-title d-flex align-items-center"
            to={routes.UPDATE_PROFILE}
          >
            <div className="plus-icon"></div>
            <span className="td-underline">Add Event</span>
          </Link>
        ) : (
          <div
            className="section-title d-flex align-items-center"
            onClick={showLoginModal}
          >
            <div className="plus-icon"></div>
            <span className="td-underline">Add Event</span>
          </div>
        )}

        <div className="">
          <div
            className={
              "events-list" + (myEvents?.length > 9 ? " two-column" : "")
            }
          >
            {myEvents.length
              ? myEvents.map((e, index) => _renderEventCell(e, index))
              : MY_EVENTS_EX.map((e, index) =>
                _renderPlaceholderEvent(e, index)
              )}
          </div>
          <div className="desc-overlay">
            When you add your events, they will be displayed here and on your
            profile. Your followers will see these on their calendars and
            receive reminders for each event.
          </div>
        </div>
      </div>
    );
  };

  const _renderGiftsSection = () => {
    return (
      <>
        <Typos.H4B className="section-title">
          <Link to={routes.GIFTGUIDES} className="text-decoration-none">
            <span className="text-light">Recommended For You</span>
          </Link>
        </Typos.H4B>
        <div>
          <div className="gift-slides-wrapper">
            <Slider {...settings3}>
              {gifts.length
                ? (gifts || []).map((item, index) => (
                  <S.SliderItem key={"giftItem" + index}>
                    <Link to={routes.GIFTGUIDES + "/" + item._id}>
                      <S.ItemImage
                        src={imageUrlFor(item.mainImage)
                          .ignoreImageParams()
                          .width(100)}
                        alt={item.title}
                        style={{ marginBottom: "10px" }}
                      />
                    </Link>
                  </S.SliderItem>
                ))
                : WISHLIST_EX.map((item, index) => (
                  <S.SliderItem
                    key={"giftItem" + index}
                    className="placeholder-item"
                  >
                    <div
                      className="placeholder-image"
                      style={{ marginBottom: "10px" }}
                    >
                      <S.ItemImage src={item.file} />
                    </div>
                  </S.SliderItem>
                ))}
            </Slider>
          </div>
          <div className="desc-overlay">
            <Typos.Desc>
              When you update your profile, you will see personalized gift ideas
              based on your interests to add to your wish list. Add your
              interests by clicking on your name above.
            </Typos.Desc>
          </div>
        </div>
      </>
    );
  };

  const _renderWishLists = () => {
    return (
      <>
        <Typos.H4B className="section-title">
          <Link to={routes.WISH_LIST} className="text-decoration-none">
            <span className="text-light">WISH LIST</span>
          </Link>
        </Typos.H4B>
        <div>
          <div className="d-flex">
            {user ? (
              <S.PlusButton as={Link} to={routes.WISH_LIST}>
                <span>+</span>
              </S.PlusButton>
            ) : (
              <S.PlusButton onClick={showLoginModal}>
                <span>+</span>
              </S.PlusButton>
            )}

            <div className="slides-wrapper">
              <div className="slides-inner">
                <Slider {...settings}>
                  {items.length
                    ? (items || []).map((item, index) => (
                      <S.SliderItem key={"wishItem" + item._id + "-" + index}>
                        <Link to={routes.WISH_LIST + "/" + item._id}>
                          <S.ItemImage
                            src={
                              item.thumbnail
                                ? item.thumbnail
                                : Images.GiftIcon
                            }
                            alt={item.name}
                            style={{ marginBottom: "10px" }}
                          />
                          {item.favorite ? (
                            <img
                              src={Images.HeartIcon}
                              className="favorite-mark"
                            />
                          ) : null}
                        </Link>
                      </S.SliderItem>
                    ))
                    : HOME_WISHLIST_EX.map((item, index) => (
                      <S.SliderItem
                        key={"wishitem" + index}
                        className="placeholder-item"
                      >
                        <div
                          className="placeholder-image"
                          style={{ marginBottom: "10px" }}
                        >
                          <S.ItemImage src={item.file} />
                        </div>
                      </S.SliderItem>
                    ))}
                  {items.length && hasMoreWishes ? (
                    <S.SliderItem key={"wishItem-more"}>
                      <S.ItemImage
                        as={Link}
                        to={routes.WISH_LIST}
                        className="more-item"
                        onClick={loadMoreWishItems}
                      >
                        <Typos.H8 className="text-white">Show More</Typos.H8>
                      </S.ItemImage>
                    </S.SliderItem>
                  ) : null}
                </Slider>
              </div>
            </div>
          </div>
          <div className="desc-overlay">
            <Typos.Desc>
              Add to your wish list from any store by clicking the + button here
              or installing the "Add to The Gift Guide" button. Looking for
              ideas? Check out the Gift Guides page, or add ideas from your
              friends' wish lists by selecting an item you like and clicking
              "add to my wish list".
            </Typos.Desc>
          </div>
        </div>
      </>
    );
  };

  const _renderFriends = () => {
    return (
      <>
        <Typos.H4B className="section-title">
          <Link to={routes.FRIENDS} className="text-decoration-none">
            <span className="text-light">Friends</span>
          </Link>
        </Typos.H4B>
        <div>
          <div className="d-flex">
            {user ? (
              <S.PlusButton as={Link} to={routes.FRIENDS}>
                <span>+</span>
              </S.PlusButton>
            ) : (
              <S.PlusButton onClick={showLoginModal}>
                <span>+</span>
              </S.PlusButton>
            )}

            <div className="slides-wrapper">
              <div className="slides-inner">
                <Slider {...settings}>
                  {friends.length
                    ? (friends || []).map((item, index) => (
                      <S.SliderItem
                        key={"friend" + item.friend?._id + "-" + index}
                      >
                        <Link
                          to={routes.ALL_USERS + "/" + item.friend?.username}
                        >
                          {item.friend?.avatar ? (
                            <S.ItemImage
                              src={item.friend?.avatar}
                              alt={item.firstname}
                              style={{ marginBottom: "10px" }}
                            />
                          ) : (
                            <S.NameAvatar>
                              {item.friend?.firstname[0]}
                              {item.friend?.lastname[0]}
                            </S.NameAvatar>
                          )}
                          <Typos.H7 className="text-center mt-1">
                            {item.friend?.firstname} {item.friend?.lastname}
                          </Typos.H7>
                        </Link>
                      </S.SliderItem>
                    ))
                    : USER_EX.map((item, index) => (
                      <S.SliderItem
                        key={"friend" + index}
                        className="placeholder-item"
                      >
                        <div
                          className="placeholder-image"
                          style={{ marginBottom: "10px" }}
                        >
                          <S.ItemImage src={item.picture} />
                        </div>
                        <Typos.H7
                          className="text-center mt-1 fake-text"
                          lines={1}
                        >
                          {item.fullname}
                        </Typos.H7>
                      </S.SliderItem>
                    ))}
                  {friends.length && hasMoreFriends ? (
                    <S.SliderItem key={"friends-more"}>
                      <S.ItemImage
                        as={Link}
                        to={routes.FRIENDS}
                        className="more-item"
                        onClick={loadMoreFriends}
                      >
                        <Typos.H8 className="text-white">Show More</Typos.H8>
                      </S.ItemImage>
                    </S.SliderItem>
                  ) : null}
                </Slider>
              </div>
            </div>
          </div>
          <div className="d-flex mt-3">
            <S.PlusButton style={{ visibility: "hidden" }}></S.PlusButton>
            <div className="slides-wrapper">
              <div className="slides-inner">
                <Slider {...settings}>
                  {followees.length
                    ? (followees || []).map((item, index) => (
                      <S.SliderItem
                        key={"followee" + item.user._id + "-" + index}
                      >
                        <FolloweeCell
                          key={"followee" + item.user._id + "-" + index}
                          user={item.user}
                          onFollowSuccess={(already) =>
                            onFollowSuccess(item, already)
                          }
                        />
                      </S.SliderItem>
                    ))
                    : FOLLOWING_EX.map((item, index) => (
                      <S.SliderItem
                        key={"followee" + index}
                        className="placeholder-item"
                      >
                        <div className="placeholder-image">
                          <S.ItemImage src={item.picture} />
                        </div>
                        <Typos.H7
                          className="text-center mt-1 mb-1 fake-text"
                          lines={1}
                        >
                          {item.fullname}
                        </Typos.H7>
                        {user ? (
                          <Btn
                            theme="outline"
                            size="small"
                            className="fake-button"
                          >
                            FOLLOW
                          </Btn>
                        ) : (
                          <Btn
                            theme="outline"
                            size="small"
                            className="fake-button"
                            onClick={showLoginModal}
                          >
                            FOLLOW
                          </Btn>
                        )}
                      </S.SliderItem>
                    ))}
                  {followees.length && hasMoreFollowings ? (
                    <S.SliderItem key={"friends-more"}>
                      <S.ItemImage
                        as="div"
                        className="more-item"
                        onClick={loadMoreFollowings}
                      >
                        <Typos.H8 className="text-white">Show More</Typos.H8>
                      </S.ItemImage>
                    </S.SliderItem>
                  ) : null}
                </Slider>
              </div>
            </div>
          </div>
          <div className="desc-overlay">
            <Typos.Desc>
              Follow friends by clicking the + button here. If users who are
              following you, that you are not yet following, you will see a
              "follow" button under their name. Looking for ideas? Check out who
              your friends are following, displayed at the bottom of their
              profile page. Can’t find a friend? Send them an invite to join.
            </Typos.Desc>
          </div>
        </div>
      </>
    );
  };

  const _renderPreference = () => {
    const favorite_thing = user?.favorites?.thing.trim();
    const favorite_store = user?.favorites?.store.trim();
    const favorite_drink = user?.favorites?.drink.trim();
    const favorite_snack = user?.favorites?.snack.trim();
    const interestings = user?.interestings || {};
    let interests = [];
    for (const key in interestings) {
      if (interestings[key]) {
        if (key === "other") {
          interests.push(interestings[key]);
        } else {
          interests.push(key.charAt(0).toUpperCase() + key.slice(1));
        }
      }
    }

    return (
      <div>
        <Typos.H4B className="section-title">
          <Link to={routes.UPDATE_PROFILE} className="text-decoration-none">
            <span className="text-light">PREFERENCES</span>
          </Link>
        </Typos.H4B>
        <div>
          <div className="">
            <div className="info-section">
              <Typos.H5>Interests</Typos.H5>
              <Typos.Desc
                className={!interests?.length ? "placeholder-desc" : ""}
              >
                {interests?.length ? (
                  interests.join(", ")
                ) : (
                  <>
                    Select your interests to be displayed on your profile page.
                    <br /> ex: fitness and athletics, cooking and baking,
                    fashion
                  </>
                )}
              </Typos.Desc>
            </div>
            <div className="info-section">
              <Typos.H5>Favorite Things</Typos.H5>
              <Typos.Desc className={!favorite_thing ? "placeholder-desc" : ""}>
                {favorite_thing ? (
                  favorite_thing
                ) : (
                  <>
                    Enter your favorite things. Include gifts to receive,
                    collections you'd like to add to, etc.
                    <br />
                    ex: candles, coffee table books, antiques, crystals
                  </>
                )}
              </Typos.Desc>
            </div>
            <div className="info-section">
              <Typos.H5>Favorite Stores</Typos.H5>
              <Typos.Desc className={!favorite_store ? "placeholder-desc" : ""}>
                {favorite_store ? (
                  favorite_store
                ) : (
                  <>
                    Enter your favorite stores. Include ideas of where to shop
                    or buy gift cards for you
                    <br />
                    ex: Nordstrom, Anthropologie, Pottery Barn, Sephora,
                    favorite local restaurant/ store
                  </>
                )}
              </Typos.Desc>
            </div>
            <div className="info-section">
              <Typos.H5>Favorite Drinks</Typos.H5>
              <Typos.Desc className={!favorite_drink ? "placeholder-desc" : ""}>
                {favorite_drink ? (
                  favorite_drink
                ) : (
                  <>
                    Enter your favorite drinks. Include beverages you would like
                    guests to bring to share at a dinner party, etc.
                    <br />
                    ex: champagne, red wine, sparkling water
                  </>
                )}
              </Typos.Desc>
            </div>
            <div className="info-section">
              <Typos.H5>Favorite Snacks, Desserts & Threats</Typos.H5>
              <Typos.Desc className={!favorite_snack ? "placeholder-desc" : ""}>
                {favorite_snack ? (
                  favorite_snack
                ) : (
                  <>
                    Enter your favorite snacks, desserts & treats. Include your
                    favorite items to share at a social gathering, road trip,
                    receive as stocking stuffers, etc.
                    <br />
                    ex: salt & vinegar chips, gummy bears, ice cream, macarons
                  </>
                )}
              </Typos.Desc>
            </div>
          </div>
          <div className="desc-overlay">
            <Typos.Desc>
              Add and update your preferences anytime to help your followers get
              ideas. This will be displayed on your profile to give other ideas
              of where to shop for you, as well as us to make gift
              recommendations for you to add to your wish list. Your responses
              will be displayed on your profile to help your followers find
              gifts for you. We will also use this information to make
              recommendations to add to your wish list.
            </Typos.Desc>
          </div>
        </div>
      </div>
    );
  };

  const _renderCalendar = () => {
    return (
      <>
        <Typos.H4B className="section-title">
          <Link to={routes.CALENDAR} className="text-decoration-none">
            <span className="text-light">CALENDAR</span>
          </Link>
        </Typos.H4B>
        <div>
          <SummaryList
            user={user}
            clickEvent={showLoginModal}
            items={events}
            filter={filterFriendEvents}
            loadMore={loadMoreFriendEvents}
          />
          <div className="desc-overlay">
            When you follow friends, their most important dates, such as
            birthdays, are added here. You will also receive reminders for these
            events, so you never miss an important date again. Select how you
            would like to receive reminders under account settings.
          </div>
        </div>
        <Modal
          open={isShare}
          onClose={() => setIsShare(false)}
          blockScroll={false}
          classNames={{
            root: "shareModalroot",
          }}
        >
          <ShareModal
            data={itemToShare}
            type="profile"
            onClose={() => setIsShare(false)}
          />
        </Modal>
      </>
    );
  };

  return (
    <React.Fragment>
      <S.AccountPage>
        <S.UserDetail>
          <div className="avatar-section">{_renderMainSection()}</div>
        </S.UserDetail>
        <S.AccountBoard>
          <div className="left-part">
            {_renderGiftsSection()}
            {_renderWishLists()}
            {_renderFriends()}
            {_renderPreference()}
          </div>
          <div className="right-part">{_renderCalendar()}</div>
        </S.AccountBoard>
        <S.BottomBar>
          <Typos.H4B as="a" onClick={openGuide}>
            START GUIDE
          </Typos.H4B>
        </S.BottomBar>
      </S.AccountPage>
      <Modal
        open={isLoginModal}
        blockScroll={false}
        onClose={() => setisLoginModal(false)}
        classNames={{
          root: "loginModalroot",
          modal: "loginModal",
        }}
      >
        <Typos.PageTitle className="login_title">
          Oops, you need to login for that
        </Typos.PageTitle>
        <div className="login_description">
          In order to use that feature, you need to log in or create an account.
        </div>
        <div className="login_btn">
          <Submit
            type="button"
            title={LOGIN_NAVIGATE_BUTTON}
            onClick={openSign}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={"next-slide " + className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <img src={Images.rightArrowIcon} alt="next" />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={"prev-slide " + className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <img src={Images.leftArrowIcon} alt="prev" />
    </div>
  );
};

export default MyProfile;
